
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {
/* ForgeContentTools.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");


var $9wGTI = parcelRequire("9wGTI");

/* ForgeContentToolsItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
function $ced39bfea5ef5993$export$9f275aff884e1431({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, dialogs: dialogs, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen); // Dialogs may not be needed anymore for live pages - this is a fix for a Forge issue where this is causing re-renders and app is losing context
    // See: https://atlassian.slack.com/archives/CFHD7ERB4/p1755775542436799?thread_ts=1754500884.539789&cid=CFHD7ERB4
    const dialogsProp = (0, $9wGTI.fg)('confluence_skip_dialogs_prop') ? undefined : dialogs;
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB,
        dialogs: dialogsProp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose, dialogs: dialogs }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                ...(0, $9wGTI.fg)('confluence_forge_content_type_in_content_actions') ? {
                    type: (0, $hIaUw.getContentType)(routeName)
                } : {}
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
            onClose();
        },
        dialogs: dialogs
    }));
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;
module.exports["forgeGlobalExtensions"] = $af2b0e533822f413$export$492ceb220fc48ad2;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("gpI6X"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("5cWfg"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("fPofH"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("dxq9B"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("9ntg5"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("01OTD"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("f4Yec"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("1qLQm"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("hiGFp"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("6gEsG"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("jP195"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("2K4NM"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("gpI6X", function(module, exports) {

let $bf3132b98c32b1cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bf3132b98c32b1cc$var$load("2YffH"),
    $bf3132b98c32b1cc$var$load("8Kivm"),
    $bf3132b98c32b1cc$var$load("cf5vC"),
    $bf3132b98c32b1cc$var$load("9njyL"),
    $bf3132b98c32b1cc$var$load("esA9a"),
    $bf3132b98c32b1cc$var$load("iQ0Jm"),
    $bf3132b98c32b1cc$var$load("coJiW"),
    $bf3132b98c32b1cc$var$load("8TKWI"),
    $bf3132b98c32b1cc$var$load("RXppq"),
    $bf3132b98c32b1cc$var$load("h4Nf7"),
    $bf3132b98c32b1cc$var$load("7f9Fz"),
    $bf3132b98c32b1cc$var$load("8YSo7"),
    $bf3132b98c32b1cc$var$load("fqGSw"),
    $bf3132b98c32b1cc$var$load("2spqH"),
    $bf3132b98c32b1cc$var$load("gWSdF"),
    $bf3132b98c32b1cc$var$load("6FuHS"),
    $bf3132b98c32b1cc$var$load("eyaRC"),
    $bf3132b98c32b1cc$var$load("g9CVe"),
    $bf3132b98c32b1cc$var$load("aeEUI"),
    $bf3132b98c32b1cc$var$load("iXzmH"),
    $bf3132b98c32b1cc$var$load("65c4i"),
    $bf3132b98c32b1cc$var$load("6wr18"),
    $bf3132b98c32b1cc$var$load("kjZZD"),
    $bf3132b98c32b1cc$var$load("3TTZL"),
    $bf3132b98c32b1cc$var$load("37ldp"),
    $bf3132b98c32b1cc$var$load("awqCy"),
    $bf3132b98c32b1cc$var$load("kHOMt"),
    $bf3132b98c32b1cc$var$load("hhss7"),
    $bf3132b98c32b1cc$var$load("e4USi"),
    $bf3132b98c32b1cc$var$load("fqika"),
    $bf3132b98c32b1cc$var$load("dlZSj"),
    $bf3132b98c32b1cc$var$load("Wowvf"),
    $bf3132b98c32b1cc$var$load("dS0Pr"),
    $bf3132b98c32b1cc$var$load("huYla"),
    $bf3132b98c32b1cc$var$load("8bVS2"),
    $bf3132b98c32b1cc$var$load("37ZO9"),
    $bf3132b98c32b1cc$var$load("1GxVg"),
    $bf3132b98c32b1cc$var$load("lTA9n"),
    $bf3132b98c32b1cc$var$load("6EQss"),
    $bf3132b98c32b1cc$var$load("6M36W"),
    $bf3132b98c32b1cc$var$load("ffEVr"),
    $bf3132b98c32b1cc$var$load("kUbUu"),
    $bf3132b98c32b1cc$var$load("9ftJe"),
    $bf3132b98c32b1cc$var$load("hUIij"),
    $bf3132b98c32b1cc$var$load("6Up0b"),
    $bf3132b98c32b1cc$var$load("lnKog"),
    $bf3132b98c32b1cc$var$load("7Omhy"),
    $bf3132b98c32b1cc$var$load("kC80R"),
    $bf3132b98c32b1cc$var$load("7EorR"),
    $bf3132b98c32b1cc$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("5cWfg", function(module, exports) {

let $3cab4107c0c47fc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3cab4107c0c47fc8$var$load("2YffH"),
    $3cab4107c0c47fc8$var$load("8Kivm"),
    $3cab4107c0c47fc8$var$load("cf5vC"),
    $3cab4107c0c47fc8$var$load("9njyL"),
    $3cab4107c0c47fc8$var$load("esA9a"),
    $3cab4107c0c47fc8$var$load("iQ0Jm"),
    $3cab4107c0c47fc8$var$load("coJiW"),
    $3cab4107c0c47fc8$var$load("8TKWI"),
    $3cab4107c0c47fc8$var$load("RXppq"),
    $3cab4107c0c47fc8$var$load("h4Nf7"),
    $3cab4107c0c47fc8$var$load("7f9Fz"),
    $3cab4107c0c47fc8$var$load("8YSo7"),
    $3cab4107c0c47fc8$var$load("fqGSw"),
    $3cab4107c0c47fc8$var$load("2spqH"),
    $3cab4107c0c47fc8$var$load("gWSdF"),
    $3cab4107c0c47fc8$var$load("6FuHS"),
    $3cab4107c0c47fc8$var$load("eyaRC"),
    $3cab4107c0c47fc8$var$load("g9CVe"),
    $3cab4107c0c47fc8$var$load("aeEUI"),
    $3cab4107c0c47fc8$var$load("iXzmH"),
    $3cab4107c0c47fc8$var$load("65c4i"),
    $3cab4107c0c47fc8$var$load("6wr18"),
    $3cab4107c0c47fc8$var$load("kjZZD"),
    $3cab4107c0c47fc8$var$load("3TTZL"),
    $3cab4107c0c47fc8$var$load("37ldp"),
    $3cab4107c0c47fc8$var$load("awqCy"),
    $3cab4107c0c47fc8$var$load("kHOMt"),
    $3cab4107c0c47fc8$var$load("hhss7"),
    $3cab4107c0c47fc8$var$load("e4USi"),
    $3cab4107c0c47fc8$var$load("fqika"),
    $3cab4107c0c47fc8$var$load("dlZSj"),
    $3cab4107c0c47fc8$var$load("Wowvf"),
    $3cab4107c0c47fc8$var$load("dS0Pr"),
    $3cab4107c0c47fc8$var$load("huYla"),
    $3cab4107c0c47fc8$var$load("8bVS2"),
    $3cab4107c0c47fc8$var$load("37ZO9"),
    $3cab4107c0c47fc8$var$load("1GxVg"),
    $3cab4107c0c47fc8$var$load("lTA9n"),
    $3cab4107c0c47fc8$var$load("6EQss"),
    $3cab4107c0c47fc8$var$load("6M36W"),
    $3cab4107c0c47fc8$var$load("ffEVr"),
    $3cab4107c0c47fc8$var$load("kUbUu"),
    $3cab4107c0c47fc8$var$load("9ftJe"),
    $3cab4107c0c47fc8$var$load("hUIij"),
    $3cab4107c0c47fc8$var$load("6Up0b"),
    $3cab4107c0c47fc8$var$load("lnKog"),
    $3cab4107c0c47fc8$var$load("7Omhy"),
    $3cab4107c0c47fc8$var$load("kC80R"),
    $3cab4107c0c47fc8$var$load("7EorR"),
    $3cab4107c0c47fc8$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("fPofH", function(module, exports) {

let $b85e6e65c22b8791$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b85e6e65c22b8791$var$load("2YffH"),
    $b85e6e65c22b8791$var$load("8Kivm"),
    $b85e6e65c22b8791$var$load("cf5vC"),
    $b85e6e65c22b8791$var$load("9njyL"),
    $b85e6e65c22b8791$var$load("esA9a"),
    $b85e6e65c22b8791$var$load("iQ0Jm"),
    $b85e6e65c22b8791$var$load("coJiW"),
    $b85e6e65c22b8791$var$load("8TKWI"),
    $b85e6e65c22b8791$var$load("RXppq"),
    $b85e6e65c22b8791$var$load("h4Nf7"),
    $b85e6e65c22b8791$var$load("7f9Fz"),
    $b85e6e65c22b8791$var$load("8YSo7"),
    $b85e6e65c22b8791$var$load("fqGSw"),
    $b85e6e65c22b8791$var$load("2spqH"),
    $b85e6e65c22b8791$var$load("gWSdF"),
    $b85e6e65c22b8791$var$load("6FuHS"),
    $b85e6e65c22b8791$var$load("eyaRC"),
    $b85e6e65c22b8791$var$load("g9CVe"),
    $b85e6e65c22b8791$var$load("aeEUI"),
    $b85e6e65c22b8791$var$load("iXzmH"),
    $b85e6e65c22b8791$var$load("65c4i"),
    $b85e6e65c22b8791$var$load("6wr18"),
    $b85e6e65c22b8791$var$load("kjZZD"),
    $b85e6e65c22b8791$var$load("3TTZL"),
    $b85e6e65c22b8791$var$load("37ldp"),
    $b85e6e65c22b8791$var$load("awqCy"),
    $b85e6e65c22b8791$var$load("kHOMt"),
    $b85e6e65c22b8791$var$load("hhss7"),
    $b85e6e65c22b8791$var$load("e4USi"),
    $b85e6e65c22b8791$var$load("fqika"),
    $b85e6e65c22b8791$var$load("dlZSj"),
    $b85e6e65c22b8791$var$load("Wowvf"),
    $b85e6e65c22b8791$var$load("dS0Pr"),
    $b85e6e65c22b8791$var$load("huYla"),
    $b85e6e65c22b8791$var$load("8bVS2"),
    $b85e6e65c22b8791$var$load("37ZO9"),
    $b85e6e65c22b8791$var$load("1GxVg"),
    $b85e6e65c22b8791$var$load("lTA9n"),
    $b85e6e65c22b8791$var$load("6EQss"),
    $b85e6e65c22b8791$var$load("6M36W"),
    $b85e6e65c22b8791$var$load("ffEVr"),
    $b85e6e65c22b8791$var$load("kUbUu"),
    $b85e6e65c22b8791$var$load("9ftJe"),
    $b85e6e65c22b8791$var$load("hUIij"),
    $b85e6e65c22b8791$var$load("6Up0b"),
    $b85e6e65c22b8791$var$load("lnKog"),
    $b85e6e65c22b8791$var$load("7Omhy"),
    $b85e6e65c22b8791$var$load("kC80R"),
    $b85e6e65c22b8791$var$load("7EorR"),
    $b85e6e65c22b8791$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("dxq9B", function(module, exports) {

let $9db2a51210224a5c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9db2a51210224a5c$var$load("6FuHS"),
    $9db2a51210224a5c$var$load("eyaRC"),
    $9db2a51210224a5c$var$load("2YffH"),
    $9db2a51210224a5c$var$load("cf5vC"),
    $9db2a51210224a5c$var$load("9njyL"),
    $9db2a51210224a5c$var$load("esA9a"),
    $9db2a51210224a5c$var$load("8TKWI"),
    $9db2a51210224a5c$var$load("RXppq"),
    $9db2a51210224a5c$var$load("h4Nf7"),
    $9db2a51210224a5c$var$load("7f9Fz"),
    $9db2a51210224a5c$var$load("8YSo7"),
    $9db2a51210224a5c$var$load("fqGSw"),
    $9db2a51210224a5c$var$load("2spqH"),
    $9db2a51210224a5c$var$load("gWSdF"),
    $9db2a51210224a5c$var$load("g9CVe"),
    $9db2a51210224a5c$var$load("aeEUI"),
    $9db2a51210224a5c$var$load("iXzmH"),
    $9db2a51210224a5c$var$load("65c4i"),
    $9db2a51210224a5c$var$load("6wr18"),
    $9db2a51210224a5c$var$load("kjZZD"),
    $9db2a51210224a5c$var$load("3TTZL"),
    $9db2a51210224a5c$var$load("37ldp"),
    $9db2a51210224a5c$var$load("awqCy"),
    $9db2a51210224a5c$var$load("kHOMt"),
    $9db2a51210224a5c$var$load("hhss7"),
    $9db2a51210224a5c$var$load("e4USi"),
    $9db2a51210224a5c$var$load("fqika"),
    $9db2a51210224a5c$var$load("dlZSj"),
    $9db2a51210224a5c$var$load("Wowvf"),
    $9db2a51210224a5c$var$load("dS0Pr"),
    $9db2a51210224a5c$var$load("huYla"),
    $9db2a51210224a5c$var$load("8bVS2"),
    $9db2a51210224a5c$var$load("37ZO9"),
    $9db2a51210224a5c$var$load("1GxVg"),
    $9db2a51210224a5c$var$load("lTA9n"),
    $9db2a51210224a5c$var$load("6EQss"),
    $9db2a51210224a5c$var$load("6M36W"),
    $9db2a51210224a5c$var$load("hUIij"),
    $9db2a51210224a5c$var$load("ffEVr"),
    $9db2a51210224a5c$var$load("kUbUu"),
    $9db2a51210224a5c$var$load("9ftJe"),
    $9db2a51210224a5c$var$load("7Omhy"),
    $9db2a51210224a5c$var$load("kC80R"),
    $9db2a51210224a5c$var$load("7EorR"),
    $9db2a51210224a5c$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("9ntg5", function(module, exports) {

let $6d3cf52f453a81d4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6d3cf52f453a81d4$var$load("6FuHS"),
    $6d3cf52f453a81d4$var$load("eyaRC"),
    $6d3cf52f453a81d4$var$load("2YffH"),
    $6d3cf52f453a81d4$var$load("cf5vC"),
    $6d3cf52f453a81d4$var$load("9njyL"),
    $6d3cf52f453a81d4$var$load("esA9a"),
    $6d3cf52f453a81d4$var$load("8TKWI"),
    $6d3cf52f453a81d4$var$load("RXppq"),
    $6d3cf52f453a81d4$var$load("h4Nf7"),
    $6d3cf52f453a81d4$var$load("7f9Fz"),
    $6d3cf52f453a81d4$var$load("8YSo7"),
    $6d3cf52f453a81d4$var$load("fqGSw"),
    $6d3cf52f453a81d4$var$load("2spqH"),
    $6d3cf52f453a81d4$var$load("gWSdF"),
    $6d3cf52f453a81d4$var$load("g9CVe"),
    $6d3cf52f453a81d4$var$load("aeEUI"),
    $6d3cf52f453a81d4$var$load("iXzmH"),
    $6d3cf52f453a81d4$var$load("65c4i"),
    $6d3cf52f453a81d4$var$load("6wr18"),
    $6d3cf52f453a81d4$var$load("kjZZD"),
    $6d3cf52f453a81d4$var$load("3TTZL"),
    $6d3cf52f453a81d4$var$load("37ldp"),
    $6d3cf52f453a81d4$var$load("awqCy"),
    $6d3cf52f453a81d4$var$load("kHOMt"),
    $6d3cf52f453a81d4$var$load("hhss7"),
    $6d3cf52f453a81d4$var$load("e4USi"),
    $6d3cf52f453a81d4$var$load("fqika"),
    $6d3cf52f453a81d4$var$load("dlZSj"),
    $6d3cf52f453a81d4$var$load("Wowvf"),
    $6d3cf52f453a81d4$var$load("dS0Pr"),
    $6d3cf52f453a81d4$var$load("huYla"),
    $6d3cf52f453a81d4$var$load("8bVS2"),
    $6d3cf52f453a81d4$var$load("37ZO9"),
    $6d3cf52f453a81d4$var$load("1GxVg"),
    $6d3cf52f453a81d4$var$load("lTA9n"),
    $6d3cf52f453a81d4$var$load("6EQss"),
    $6d3cf52f453a81d4$var$load("6M36W"),
    $6d3cf52f453a81d4$var$load("hUIij"),
    $6d3cf52f453a81d4$var$load("ffEVr"),
    $6d3cf52f453a81d4$var$load("kUbUu"),
    $6d3cf52f453a81d4$var$load("9ftJe"),
    $6d3cf52f453a81d4$var$load("7Omhy"),
    $6d3cf52f453a81d4$var$load("kC80R"),
    $6d3cf52f453a81d4$var$load("7EorR"),
    $6d3cf52f453a81d4$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("01OTD", function(module, exports) {

let $00016999152c04eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00016999152c04eb$var$load("6FuHS"),
    $00016999152c04eb$var$load("eyaRC"),
    $00016999152c04eb$var$load("2YffH"),
    $00016999152c04eb$var$load("cf5vC"),
    $00016999152c04eb$var$load("9njyL"),
    $00016999152c04eb$var$load("esA9a"),
    $00016999152c04eb$var$load("8TKWI"),
    $00016999152c04eb$var$load("RXppq"),
    $00016999152c04eb$var$load("h4Nf7"),
    $00016999152c04eb$var$load("7f9Fz"),
    $00016999152c04eb$var$load("8YSo7"),
    $00016999152c04eb$var$load("fqGSw"),
    $00016999152c04eb$var$load("2spqH"),
    $00016999152c04eb$var$load("gWSdF"),
    $00016999152c04eb$var$load("g9CVe"),
    $00016999152c04eb$var$load("aeEUI"),
    $00016999152c04eb$var$load("iXzmH"),
    $00016999152c04eb$var$load("65c4i"),
    $00016999152c04eb$var$load("6wr18"),
    $00016999152c04eb$var$load("kjZZD"),
    $00016999152c04eb$var$load("3TTZL"),
    $00016999152c04eb$var$load("37ldp"),
    $00016999152c04eb$var$load("awqCy"),
    $00016999152c04eb$var$load("kHOMt"),
    $00016999152c04eb$var$load("hhss7"),
    $00016999152c04eb$var$load("e4USi"),
    $00016999152c04eb$var$load("fqika"),
    $00016999152c04eb$var$load("dlZSj"),
    $00016999152c04eb$var$load("Wowvf"),
    $00016999152c04eb$var$load("dS0Pr"),
    $00016999152c04eb$var$load("huYla"),
    $00016999152c04eb$var$load("8bVS2"),
    $00016999152c04eb$var$load("37ZO9"),
    $00016999152c04eb$var$load("1GxVg"),
    $00016999152c04eb$var$load("lTA9n"),
    $00016999152c04eb$var$load("6EQss"),
    $00016999152c04eb$var$load("6M36W"),
    $00016999152c04eb$var$load("hUIij"),
    $00016999152c04eb$var$load("ffEVr"),
    $00016999152c04eb$var$load("kUbUu"),
    $00016999152c04eb$var$load("9ftJe"),
    $00016999152c04eb$var$load("7Omhy"),
    $00016999152c04eb$var$load("kC80R"),
    $00016999152c04eb$var$load("7EorR"),
    $00016999152c04eb$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("f4Yec", function(module, exports) {

let $afa5f2c4fc309014$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $afa5f2c4fc309014$var$load("6FuHS"),
    $afa5f2c4fc309014$var$load("eyaRC"),
    $afa5f2c4fc309014$var$load("2YffH"),
    $afa5f2c4fc309014$var$load("cf5vC"),
    $afa5f2c4fc309014$var$load("9njyL"),
    $afa5f2c4fc309014$var$load("esA9a"),
    $afa5f2c4fc309014$var$load("8TKWI"),
    $afa5f2c4fc309014$var$load("RXppq"),
    $afa5f2c4fc309014$var$load("h4Nf7"),
    $afa5f2c4fc309014$var$load("7f9Fz"),
    $afa5f2c4fc309014$var$load("8YSo7"),
    $afa5f2c4fc309014$var$load("fqGSw"),
    $afa5f2c4fc309014$var$load("2spqH"),
    $afa5f2c4fc309014$var$load("gWSdF"),
    $afa5f2c4fc309014$var$load("g9CVe"),
    $afa5f2c4fc309014$var$load("aeEUI"),
    $afa5f2c4fc309014$var$load("iXzmH"),
    $afa5f2c4fc309014$var$load("65c4i"),
    $afa5f2c4fc309014$var$load("6wr18"),
    $afa5f2c4fc309014$var$load("kjZZD"),
    $afa5f2c4fc309014$var$load("3TTZL"),
    $afa5f2c4fc309014$var$load("37ldp"),
    $afa5f2c4fc309014$var$load("awqCy"),
    $afa5f2c4fc309014$var$load("kHOMt"),
    $afa5f2c4fc309014$var$load("hhss7"),
    $afa5f2c4fc309014$var$load("e4USi"),
    $afa5f2c4fc309014$var$load("fqika"),
    $afa5f2c4fc309014$var$load("dlZSj"),
    $afa5f2c4fc309014$var$load("Wowvf"),
    $afa5f2c4fc309014$var$load("dS0Pr"),
    $afa5f2c4fc309014$var$load("huYla"),
    $afa5f2c4fc309014$var$load("8bVS2"),
    $afa5f2c4fc309014$var$load("37ZO9"),
    $afa5f2c4fc309014$var$load("1GxVg"),
    $afa5f2c4fc309014$var$load("lTA9n"),
    $afa5f2c4fc309014$var$load("6EQss"),
    $afa5f2c4fc309014$var$load("6M36W"),
    $afa5f2c4fc309014$var$load("ffEVr"),
    $afa5f2c4fc309014$var$load("kUbUu"),
    $afa5f2c4fc309014$var$load("9ftJe"),
    $afa5f2c4fc309014$var$load("hUIij"),
    $afa5f2c4fc309014$var$load("6Up0b"),
    $afa5f2c4fc309014$var$load("lnKog"),
    $afa5f2c4fc309014$var$load("7Omhy"),
    $afa5f2c4fc309014$var$load("kC80R"),
    $afa5f2c4fc309014$var$load("7EorR"),
    $afa5f2c4fc309014$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("1qLQm", function(module, exports) {

let $10ad54e29eeae8d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $10ad54e29eeae8d1$var$load("2YffH"),
    $10ad54e29eeae8d1$var$load("cf5vC"),
    $10ad54e29eeae8d1$var$load("9njyL"),
    $10ad54e29eeae8d1$var$load("esA9a"),
    $10ad54e29eeae8d1$var$load("coJiW"),
    $10ad54e29eeae8d1$var$load("8TKWI"),
    $10ad54e29eeae8d1$var$load("RXppq"),
    $10ad54e29eeae8d1$var$load("h4Nf7"),
    $10ad54e29eeae8d1$var$load("7f9Fz"),
    $10ad54e29eeae8d1$var$load("8YSo7"),
    $10ad54e29eeae8d1$var$load("fqGSw"),
    $10ad54e29eeae8d1$var$load("2spqH"),
    $10ad54e29eeae8d1$var$load("gWSdF"),
    $10ad54e29eeae8d1$var$load("6FuHS"),
    $10ad54e29eeae8d1$var$load("eyaRC"),
    $10ad54e29eeae8d1$var$load("g9CVe"),
    $10ad54e29eeae8d1$var$load("aeEUI"),
    $10ad54e29eeae8d1$var$load("iXzmH"),
    $10ad54e29eeae8d1$var$load("65c4i"),
    $10ad54e29eeae8d1$var$load("6wr18"),
    $10ad54e29eeae8d1$var$load("kjZZD"),
    $10ad54e29eeae8d1$var$load("3TTZL"),
    $10ad54e29eeae8d1$var$load("37ldp"),
    $10ad54e29eeae8d1$var$load("dTsOE"),
    $10ad54e29eeae8d1$var$load("awqCy"),
    $10ad54e29eeae8d1$var$load("kHOMt"),
    $10ad54e29eeae8d1$var$load("hhss7"),
    $10ad54e29eeae8d1$var$load("e4USi"),
    $10ad54e29eeae8d1$var$load("fqika"),
    $10ad54e29eeae8d1$var$load("dlZSj"),
    $10ad54e29eeae8d1$var$load("Wowvf"),
    $10ad54e29eeae8d1$var$load("dS0Pr"),
    $10ad54e29eeae8d1$var$load("huYla"),
    $10ad54e29eeae8d1$var$load("8bVS2"),
    $10ad54e29eeae8d1$var$load("37ZO9"),
    $10ad54e29eeae8d1$var$load("1GxVg"),
    $10ad54e29eeae8d1$var$load("lTA9n"),
    $10ad54e29eeae8d1$var$load("6EQss"),
    $10ad54e29eeae8d1$var$load("6M36W"),
    $10ad54e29eeae8d1$var$load("ffEVr"),
    $10ad54e29eeae8d1$var$load("kUbUu"),
    $10ad54e29eeae8d1$var$load("9ftJe"),
    $10ad54e29eeae8d1$var$load("hUIij"),
    $10ad54e29eeae8d1$var$load("6Up0b"),
    $10ad54e29eeae8d1$var$load("lnKog"),
    $10ad54e29eeae8d1$var$load("7Omhy"),
    $10ad54e29eeae8d1$var$load("kC80R"),
    $10ad54e29eeae8d1$var$load("7EorR"),
    $10ad54e29eeae8d1$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("hiGFp", function(module, exports) {

let $c98536e15fc16739$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c98536e15fc16739$var$load("2YffH"),
    $c98536e15fc16739$var$load("cf5vC"),
    $c98536e15fc16739$var$load("9njyL"),
    $c98536e15fc16739$var$load("esA9a"),
    $c98536e15fc16739$var$load("coJiW"),
    $c98536e15fc16739$var$load("8TKWI"),
    $c98536e15fc16739$var$load("RXppq"),
    $c98536e15fc16739$var$load("h4Nf7"),
    $c98536e15fc16739$var$load("7f9Fz"),
    $c98536e15fc16739$var$load("8YSo7"),
    $c98536e15fc16739$var$load("fqGSw"),
    $c98536e15fc16739$var$load("2spqH"),
    $c98536e15fc16739$var$load("gWSdF"),
    $c98536e15fc16739$var$load("6FuHS"),
    $c98536e15fc16739$var$load("eyaRC"),
    $c98536e15fc16739$var$load("g9CVe"),
    $c98536e15fc16739$var$load("aeEUI"),
    $c98536e15fc16739$var$load("iXzmH"),
    $c98536e15fc16739$var$load("65c4i"),
    $c98536e15fc16739$var$load("6wr18"),
    $c98536e15fc16739$var$load("kjZZD"),
    $c98536e15fc16739$var$load("3TTZL"),
    $c98536e15fc16739$var$load("37ldp"),
    $c98536e15fc16739$var$load("dTsOE"),
    $c98536e15fc16739$var$load("awqCy"),
    $c98536e15fc16739$var$load("kHOMt"),
    $c98536e15fc16739$var$load("hhss7"),
    $c98536e15fc16739$var$load("e4USi"),
    $c98536e15fc16739$var$load("fqika"),
    $c98536e15fc16739$var$load("dlZSj"),
    $c98536e15fc16739$var$load("Wowvf"),
    $c98536e15fc16739$var$load("dS0Pr"),
    $c98536e15fc16739$var$load("huYla"),
    $c98536e15fc16739$var$load("8bVS2"),
    $c98536e15fc16739$var$load("37ZO9"),
    $c98536e15fc16739$var$load("1GxVg"),
    $c98536e15fc16739$var$load("lTA9n"),
    $c98536e15fc16739$var$load("6EQss"),
    $c98536e15fc16739$var$load("6M36W"),
    $c98536e15fc16739$var$load("ffEVr"),
    $c98536e15fc16739$var$load("kUbUu"),
    $c98536e15fc16739$var$load("9ftJe"),
    $c98536e15fc16739$var$load("hUIij"),
    $c98536e15fc16739$var$load("6Up0b"),
    $c98536e15fc16739$var$load("lnKog"),
    $c98536e15fc16739$var$load("7Omhy"),
    $c98536e15fc16739$var$load("kC80R"),
    $c98536e15fc16739$var$load("7EorR"),
    $c98536e15fc16739$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("6gEsG", function(module, exports) {

let $49039f86ff7e86b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $49039f86ff7e86b5$var$load("6FuHS"),
    $49039f86ff7e86b5$var$load("eyaRC"),
    $49039f86ff7e86b5$var$load("2YffH"),
    $49039f86ff7e86b5$var$load("cf5vC"),
    $49039f86ff7e86b5$var$load("9njyL"),
    $49039f86ff7e86b5$var$load("esA9a"),
    $49039f86ff7e86b5$var$load("8TKWI"),
    $49039f86ff7e86b5$var$load("RXppq"),
    $49039f86ff7e86b5$var$load("h4Nf7"),
    $49039f86ff7e86b5$var$load("7f9Fz"),
    $49039f86ff7e86b5$var$load("8YSo7"),
    $49039f86ff7e86b5$var$load("fqGSw"),
    $49039f86ff7e86b5$var$load("2spqH"),
    $49039f86ff7e86b5$var$load("gWSdF"),
    $49039f86ff7e86b5$var$load("g9CVe"),
    $49039f86ff7e86b5$var$load("aeEUI"),
    $49039f86ff7e86b5$var$load("iXzmH"),
    $49039f86ff7e86b5$var$load("65c4i"),
    $49039f86ff7e86b5$var$load("6wr18"),
    $49039f86ff7e86b5$var$load("kjZZD"),
    $49039f86ff7e86b5$var$load("3TTZL"),
    $49039f86ff7e86b5$var$load("37ldp"),
    $49039f86ff7e86b5$var$load("awqCy"),
    $49039f86ff7e86b5$var$load("kHOMt"),
    $49039f86ff7e86b5$var$load("hhss7"),
    $49039f86ff7e86b5$var$load("e4USi"),
    $49039f86ff7e86b5$var$load("fqika"),
    $49039f86ff7e86b5$var$load("dlZSj"),
    $49039f86ff7e86b5$var$load("Wowvf"),
    $49039f86ff7e86b5$var$load("dS0Pr"),
    $49039f86ff7e86b5$var$load("huYla"),
    $49039f86ff7e86b5$var$load("8bVS2"),
    $49039f86ff7e86b5$var$load("37ZO9"),
    $49039f86ff7e86b5$var$load("1GxVg"),
    $49039f86ff7e86b5$var$load("lTA9n"),
    $49039f86ff7e86b5$var$load("6EQss"),
    $49039f86ff7e86b5$var$load("6M36W"),
    $49039f86ff7e86b5$var$load("hUIij"),
    $49039f86ff7e86b5$var$load("ffEVr"),
    $49039f86ff7e86b5$var$load("kUbUu"),
    $49039f86ff7e86b5$var$load("9ftJe"),
    $49039f86ff7e86b5$var$load("7Omhy"),
    $49039f86ff7e86b5$var$load("kC80R"),
    $49039f86ff7e86b5$var$load("7EorR"),
    $49039f86ff7e86b5$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("jP195", function(module, exports) {

let $e6e3ab339aa05f2e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e6e3ab339aa05f2e$var$load("6FuHS"),
    $e6e3ab339aa05f2e$var$load("eyaRC"),
    $e6e3ab339aa05f2e$var$load("2YffH"),
    $e6e3ab339aa05f2e$var$load("cf5vC"),
    $e6e3ab339aa05f2e$var$load("9njyL"),
    $e6e3ab339aa05f2e$var$load("esA9a"),
    $e6e3ab339aa05f2e$var$load("8TKWI"),
    $e6e3ab339aa05f2e$var$load("RXppq"),
    $e6e3ab339aa05f2e$var$load("h4Nf7"),
    $e6e3ab339aa05f2e$var$load("7f9Fz"),
    $e6e3ab339aa05f2e$var$load("8YSo7"),
    $e6e3ab339aa05f2e$var$load("fqGSw"),
    $e6e3ab339aa05f2e$var$load("2spqH"),
    $e6e3ab339aa05f2e$var$load("gWSdF"),
    $e6e3ab339aa05f2e$var$load("g9CVe"),
    $e6e3ab339aa05f2e$var$load("aeEUI"),
    $e6e3ab339aa05f2e$var$load("iXzmH"),
    $e6e3ab339aa05f2e$var$load("65c4i"),
    $e6e3ab339aa05f2e$var$load("6wr18"),
    $e6e3ab339aa05f2e$var$load("kjZZD"),
    $e6e3ab339aa05f2e$var$load("3TTZL"),
    $e6e3ab339aa05f2e$var$load("37ldp"),
    $e6e3ab339aa05f2e$var$load("awqCy"),
    $e6e3ab339aa05f2e$var$load("kHOMt"),
    $e6e3ab339aa05f2e$var$load("hhss7"),
    $e6e3ab339aa05f2e$var$load("e4USi"),
    $e6e3ab339aa05f2e$var$load("fqika"),
    $e6e3ab339aa05f2e$var$load("dlZSj"),
    $e6e3ab339aa05f2e$var$load("Wowvf"),
    $e6e3ab339aa05f2e$var$load("dS0Pr"),
    $e6e3ab339aa05f2e$var$load("huYla"),
    $e6e3ab339aa05f2e$var$load("8bVS2"),
    $e6e3ab339aa05f2e$var$load("37ZO9"),
    $e6e3ab339aa05f2e$var$load("1GxVg"),
    $e6e3ab339aa05f2e$var$load("lTA9n"),
    $e6e3ab339aa05f2e$var$load("6EQss"),
    $e6e3ab339aa05f2e$var$load("6M36W"),
    $e6e3ab339aa05f2e$var$load("ffEVr"),
    $e6e3ab339aa05f2e$var$load("kUbUu"),
    $e6e3ab339aa05f2e$var$load("9ftJe"),
    $e6e3ab339aa05f2e$var$load("hUIij"),
    $e6e3ab339aa05f2e$var$load("6Up0b"),
    $e6e3ab339aa05f2e$var$load("lnKog"),
    $e6e3ab339aa05f2e$var$load("7Omhy"),
    $e6e3ab339aa05f2e$var$load("kC80R"),
    $e6e3ab339aa05f2e$var$load("7EorR"),
    $e6e3ab339aa05f2e$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("2K4NM", function(module, exports) {

let $1ff39a33d474090e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1ff39a33d474090e$var$load("6FuHS"),
    $1ff39a33d474090e$var$load("eyaRC"),
    $1ff39a33d474090e$var$load("2YffH"),
    $1ff39a33d474090e$var$load("cf5vC"),
    $1ff39a33d474090e$var$load("9njyL"),
    $1ff39a33d474090e$var$load("esA9a"),
    $1ff39a33d474090e$var$load("8TKWI"),
    $1ff39a33d474090e$var$load("RXppq"),
    $1ff39a33d474090e$var$load("h4Nf7"),
    $1ff39a33d474090e$var$load("7f9Fz"),
    $1ff39a33d474090e$var$load("8YSo7"),
    $1ff39a33d474090e$var$load("fqGSw"),
    $1ff39a33d474090e$var$load("2spqH"),
    $1ff39a33d474090e$var$load("gWSdF"),
    $1ff39a33d474090e$var$load("g9CVe"),
    $1ff39a33d474090e$var$load("aeEUI"),
    $1ff39a33d474090e$var$load("iXzmH"),
    $1ff39a33d474090e$var$load("65c4i"),
    $1ff39a33d474090e$var$load("6wr18"),
    $1ff39a33d474090e$var$load("kjZZD"),
    $1ff39a33d474090e$var$load("3TTZL"),
    $1ff39a33d474090e$var$load("37ldp"),
    $1ff39a33d474090e$var$load("awqCy"),
    $1ff39a33d474090e$var$load("kHOMt"),
    $1ff39a33d474090e$var$load("hhss7"),
    $1ff39a33d474090e$var$load("e4USi"),
    $1ff39a33d474090e$var$load("fqika"),
    $1ff39a33d474090e$var$load("dlZSj"),
    $1ff39a33d474090e$var$load("Wowvf"),
    $1ff39a33d474090e$var$load("dS0Pr"),
    $1ff39a33d474090e$var$load("huYla"),
    $1ff39a33d474090e$var$load("8bVS2"),
    $1ff39a33d474090e$var$load("37ZO9"),
    $1ff39a33d474090e$var$load("1GxVg"),
    $1ff39a33d474090e$var$load("lTA9n"),
    $1ff39a33d474090e$var$load("6EQss"),
    $1ff39a33d474090e$var$load("6M36W"),
    $1ff39a33d474090e$var$load("ffEVr"),
    $1ff39a33d474090e$var$load("kUbUu"),
    $1ff39a33d474090e$var$load("9ftJe"),
    $1ff39a33d474090e$var$load("hUIij"),
    $1ff39a33d474090e$var$load("6Up0b"),
    $1ff39a33d474090e$var$load("lnKog"),
    $1ff39a33d474090e$var$load("7Omhy"),
    $1ff39a33d474090e$var$load("kC80R"),
    $1ff39a33d474090e$var$load("7EorR"),
    $1ff39a33d474090e$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("dVFAI"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("dVFAI", function(module, exports) {

let $a240dc5be70b389e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a240dc5be70b389e$var$load("hUIij"),
    $a240dc5be70b389e$var$load("6Up0b"),
    $a240dc5be70b389e$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.50b9bc3d.js.map
